import { Component, OnInit, Input } from '@angular/core';
import { TableComponent } from "app/components/common/table/table.component";
import { TableAction } from "../table.action";
import {RestService} from "../../../../services/rest.service";



@Component({
  selector: 'app-table-action',
  templateUrl: './table-action.component.html',
  styleUrls: ['./table-action.component.css']
})
export class TableActionComponent implements OnInit, TableAction {

  @Input()
  public icon: string;

  @Input()
  public label?: string = null;

  @Input()
  public action: (obj: any) => any; 

  @Input() disabled?: boolean = false;

  @Input()
  public conditional?: (obj: any) => boolean;
  
  constructor(private tableComponent: TableComponent,
    private _rest: RestService) {

  }

  ngOnInit() {
      this.tableComponent.addAction(this);
  }
}
